export default __webpack_public_path__ + "static/client1-9f10fc8984e146b50a80f2ea59546aa9.svg";